import { PlayerDictionary } from "components/game/CompletedStory";
import { GameStatePlayerDto } from "dtos/frankenstories/GameStatePlayerDto";
import { useEffect, useState } from "react";
import { GameStateProps } from "types/GameStateProps";
import { AssetManager } from "utils/AssetManager";

export const Leaderboard = (
    props: GameStateProps & {
        selectPlayer: (p: GameStatePlayerDto) => void;
        playerNames: PlayerDictionary;
    },
) => {
    const { gameState, selectPlayer, playerNames } = props;

    const { characters } = AssetManager;

    const [sortedPlayers, setSortedPlayers] = useState<Array<GameStatePlayerDto>>([]);

    // sort players
    useEffect(() => {
        if (gameState?.players) {
            const players = [...gameState.players].filter(x => x.voteCount);

            players.sort((a, b) => {
                // sort by votes first
                if (a.voteCount > b.voteCount) {
                    return -1;
                } else if (a.voteCount < b.voteCount) {
                    return 1;
                }

                // then by likes
                if (a.reactionCount > b.reactionCount) {
                    return -1;
                } else if (a.reactionCount < b.reactionCount) {
                    return 1;
                }

                // default
                return 0;
            });

            setSortedPlayers(players);
        }
    }, [gameState?.players]);

    return (
        <div className="list-group vstack gap-2 w-100">
            {sortedPlayers.map(p => {
                const playerName = playerNames[p.id];

                return (
                    <button
                        type="button"
                        key={p.id}
                        className="list-group-item list-group-item-action py-0"
                        onClick={() => {
                            selectPlayer(p);
                        }}
                    >
                        <div className="grid gap-lg-5">
                            <div className="g-col-6 d-flex flex-row align-items-center gap-3">
                                <div className="d-none d-lg-flex align-items-end h-100">
                                    {p.characterId != null && (
                                        <img alt="" style={{ width: 70 }} src={characters[p.characterId]} />
                                    )}
                                </div>
                                <div className="py-3 fw-bold justify-content-center text-dark">{playerName}</div>
                            </div>

                            <div className="g-col-3 py-3 text-nowrap d-flex align-items-center justify-content-center">
                                {p.voteCount} {p.voteCount === 1 ? "vote" : "votes"}
                            </div>

                            {p.reactionCount > 0 && (
                                <div className="g-col-3 py-3 d-flex align-items-center gap-2 justify-content-center">
                                    <span>❤️</span>
                                    <span>{p.reactionCount}</span>
                                </div>
                            )}
                        </div>
                    </button>
                );
            })}
        </div>
    );
};
